/* BOOSTECOM - Bundle : remise 12 boules, cible en 1 clic, prix dans le bouton ATC.
   Aucune dependance. Idempotent. Charge par snippets/bundle-extras_boostecom.liquid */
(function () {
  if (window.__bxBundleLoaded) return;
  window.__bxBundleLoaded = true;

  var LOCALE = document.documentElement.lang || 'fr-FR';
  var ROOT = (window.Theme && window.Theme.routes && window.Theme.routes.root) || '/';

  /* Reproduit le money_format de la boutique (ex: {{amount_with_comma_separator}}€) */
  function fmt(cents, c, short) {
    cents = Math.round(cents);
    var f = (c && c.format) || '';
    var m = f.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/);
    var whole = cents % 100 === 0; /* prix ronds sans decimales */
    if (!m) {
      return new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency: (c && c.currency) || 'EUR',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    }
    var kind = m[1];
    var noDec = whole || kind.indexOf('no_decimals') > -1;
    var thousands = ',';
    var decimal = '.';
    if (kind.indexOf('comma_separator') > -1) { thousands = '.'; decimal = ','; }
    else if (kind.indexOf('space_separator') > -1) { thousands = ' '; decimal = ','; }
    else if (kind.indexOf('apostrophe') > -1) { thousands = "'"; }
    var intPart = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = noDec ? intPart : intPart + decimal + ('0' + (cents % 100)).slice(-2);
    return f.replace(m[0], out);
  }

  function ctx() {
    var root = document.querySelector('[data-bx-extras]');
    if (!root) return null;
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-bx-variants]').textContent);
    } catch (e) {}
    return {
      root: root,
      scope: root.closest('.shopify-section') || document,
      variants: variants,
      currency: root.dataset.currency || 'EUR',
      format: root.dataset.moneyFormat || ''
    };
  }

  function byId(variants, id) {
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return null;
  }

  function selectedId(c) {
    var r = c.scope.querySelector('.variant-option--bundle input[type="radio"]:checked');
    if (r && r.dataset.variantId) return Number(r.dataset.variantId);
    var form = c.root.closest('form');
    var input = form && form.querySelector('input[name="id"]');
    return input ? Number(input.value) : null;
  }

  /* Reference = plus petit pack (ex: 6 boules). On compare le prix par boule. */
  function analyse(variants) {
    var av = variants.filter(function (v) { return v.n > 0; });
    if (av.length < 2) return null;
    var baseN = Math.min.apply(null, av.map(function (v) { return v.n; }));
    var basePpb = Math.min.apply(null, av.filter(function (v) { return v.n === baseN; }).map(function (v) { return v.price / v.n; }));
    return { av: av, baseN: baseN, basePpb: basePpb };
  }

  function refreshBadges(c) {
    var a = analyse(c.variants);
    c.scope.querySelectorAll('.variant-option--bundle input[type="radio"][data-variant-id]').forEach(function (input) {
      var card = input.closest('.variant-option__bundle-card');
      if (!card) return;
      var v = byId(c.variants, Number(input.dataset.variantId));
      var txt = '';
      if (v && v.compare > v.price) {
        /* Remise réelle (prix barré) : badge sur toutes les cartes, y compris les plus petits packs */
        txt = '−' + fmt(v.compare - v.price, c);
      } else if (a && v && v.n > a.baseN && v.price / v.n < a.basePpb) {
        var gain = v.compare > v.price
          ? v.compare - v.price
          : a.basePpb * v.n - v.price;
        if (gain > 0) txt = '−' + fmt(gain, c);
      }
      var badge = card.querySelector('.bx-badge');
      if (!txt) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'bx-badge';
        (card.querySelector('.variant-option__bundle-card__content--custom') ||
          card.querySelector('.variant-option__bundle-card__inner') || card).appendChild(badge);
      }
      if (badge.textContent !== txt) badge.textContent = txt;
    });
  }

  function scopeOf(form) {
    return form.closest('.shopify-section') || document;
  }

  function crossPrice(form) {
    var scope = scopeOf(form);
    var cb = scope.querySelector('[data-bx-cross-checkbox]');
    var v = scope.querySelector('[data-bx-cross-variant]');
    if (!cb || !cb.checked || !v) return 0;
    var opt = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
    return Number(opt && opt.dataset.price) || 0;
  }

  function refreshAtc(c) {
    document.querySelectorAll('[data-atc-price]').forEach(function (el) {
      var form = el.closest('form');
      if (!form) return;
      var q = form.querySelector('input[name="quantity"]');
      var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      var unit = Number(el.dataset.unitPrice) || 0;
      var cmp = Number(el.dataset.unitCompare) || 0;
      var cross = crossPrice(form);
      var cur = c;
      var now = fmt(unit * qty + cross, cur);
      var nowEl = el.querySelector('.atc-price__now');
      if (nowEl && nowEl.textContent !== now) nowEl.textContent = now;
      var oldEl = el.querySelector('.atc-price__old');
      if (cmp > unit) {
        var old = fmt(cmp * qty + cross, cur);
        if (!oldEl) {
          oldEl = document.createElement('s');
          oldEl.className = 'atc-price__old';
          el.appendChild(oldEl);
        }
        if (oldEl.textContent !== old) oldEl.textContent = old;
      } else if (oldEl) {
        oldEl.remove();
      }
    });
    document.querySelectorAll('[data-bx-cross]').forEach(function (box) {
      var cb = box.querySelector('[data-bx-cross-checkbox]');
      var sel = box.querySelector('select[data-bx-cross-variant]');
      if (sel) sel.hidden = !(cb && cb.checked);
    });
  }

  function refreshAll() {
    var c = ctx();
    if (!c) return;
    refreshBadges(c);
    refreshAtc(c);
  }

  var raf = 0;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      refreshAll();
    });
  }

  ['change', 'input', 'click'].forEach(function (t) { document.addEventListener(t, schedule); });
  ['quantity-selector:update', 'variant:selected', 'variant:update'].forEach(function (t) {
    document.addEventListener(t, schedule);
  });

  /* Ajout de la cible : appel silencieux, puis soumission normale du formulaire du theme */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (form.dataset.bxPass === '1') {
      delete form.dataset.bxPass;
      return;
    }
    var scope = scopeOf(form);
    var cb = scope.querySelector('[data-bx-cross-checkbox]');
    if (!cb || !cb.checked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var vEl = scope.querySelector('[data-bx-cross-variant]');
    var id = vEl ? Number(vEl.value) : 0;
    var pending = id
      ? fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) { return r.ok; }).catch(function () { return false; })
      : Promise.resolve(false);
    pending.then(function (ok) {
      if (ok) {
        window.__bxExtraAdded = 1;
        cb.checked = false;
        schedule();
      }
      form.dataset.bxPass = '1';
      form.requestSubmit();
    });
  }, true);

  /* La pastille du header compte la cible ajoutee en silence */
  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data;
    if (!window.__bxExtraAdded || !d || d.source !== 'product-form-component') return;
    window.__bxExtraAdded = 0;
    setTimeout(function () {
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('cart-icon').forEach(function (i) { i.currentCartCount = cart.item_count; });
          try {
            sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() }));
          } catch (_) {}
        })
        .catch(function () {});
    }, 0);
  });

  /* Re-applique badges / prix apres les re-rendus (morph) du theme */
  function observe() {
    var c = ctx();
    var target = (c && c.scope !== document ? c.scope : null) || document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
    refreshAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
})();
